// additional libs
import './utils/lite-youtube-embed'

import './style/styles-default.scss'

import { createComponent } from '@bigyouth/base'
import * as features from './features/exports/default'

Object.values(features).forEach(createComponent)
